// src/data/products.js
export const products = [
  // Amazon Cards
  {
    id: 1,
    name: "$100 Gift Card",
    brand: "Amazon",
    faceValue: 100,
    price: 25,
    imageUrl: "https://i.postimg.cc/Zn9vqQPc/w-1500.avif",
  },
  {
    id: 2,
    name: "$1,500 Gift Card",
    brand: "Amazon",
    faceValue: 1500,
    price: 375,
    imageUrl: "https://i.postimg.cc/Zn9vqQPc/w-1500.avif",
  },
  {
    id: 3,
    name: "$2,000 Gift Card",
    brand: "Amazon",
    faceValue: 2000,
    price: 500,
    imageUrl: "https://i.postimg.cc/Zn9vqQPc/w-1500.avif",
  },
  {
    id: 4,
    name: "$4,000 Gift Card",
    brand: "Amazon",
    faceValue: 4000,
    price: 1000,
    imageUrl: "https://i.postimg.cc/Zn9vqQPc/w-1500.avif",
  },
  // Binance Cards
  {
    id: 5,
    name: "$500 Gift Card",
    brand: "Binance",
    faceValue: 500,
    price: 125,
    imageUrl: "https://i.postimg.cc/rFjzkM21/w-1500-(1).avif",
  },
  {
    id: 6,
    name: "$1,000 Gift Card",
    brand: "Binance",
    faceValue: 1000,
    price: 250,
    imageUrl: "https://i.postimg.cc/rFjzkM21/w-1500-(1).avif",
  },
  {
    id: 7,
    name: "$1,500 Gift Card",
    brand: "Binance",
    faceValue: 1500,
    price: 375,
    imageUrl: "https://i.postimg.cc/rFjzkM21/w-1500-(1).avif",
  },
  {
    id: 8,
    name: "$2,500 Gift Card",
    brand: "Binance",
    faceValue: 2500,
    price: 625,
    imageUrl: "https://i.postimg.cc/rFjzkM21/w-1500-(1).avif",
  },
  // Google Play Cards – added with similar pricing as Amazon
  {
    id: 9,
    name: "$100 Gift Card",
    brand: "Google Play",
    faceValue: 100,
    price: 25,
    imageUrl: "https://i.postimg.cc/X7KTCSRW/images.png",
  },
  {
    id: 10,
    name: "$500 Gift Card",
    brand: "Google Play",
    faceValue: 500,
    price: 125,
    imageUrl: "https://i.postimg.cc/X7KTCSRW/images.png",
  },
  {
    id: 11,
    name: "$1,000 Gift Card",
    brand: "Google Play",
    faceValue: 1000,
    price: 250,
    imageUrl: "https://i.postimg.cc/X7KTCSRW/images.png",
  },
  {
    id: 12,
    name: "$1,500 Gift Card",
    brand: "Google Play",
    faceValue: 1500,
    price: 375,
    imageUrl: "https://i.postimg.cc/X7KTCSRW/images.png",
  },
  {
    id: 13,
    name: "$2,000 Gift Card",
    brand: "Google Play",
    faceValue: 2000,
    price: 500,
    imageUrl: "https://i.postimg.cc/X7KTCSRW/images.png",
  },
  {
    id: 14,
    name: "$4,000 Gift Card",
    brand: "Google Play",
    faceValue: 4000,
    price: 1000,
    imageUrl: "https://i.postimg.cc/X7KTCSRW/images.png",
  },
];